<template>
  <header
    :class="[ns.b(), ns.is('dark', dark), ns.is('mac', isMac)]"
    aria-label="窗口标题栏"
    data-tauri-drag-region
  >
    <div :class="ns.e('content')">
      <div :class="ns.e('brand')">
        <slot name="brand" />
      </div>
      <div :id="navId" :class="ns.e('nav')">
        <slot name="nav" />
      </div>
      <div :class="ns.e('drag')" aria-hidden="true" data-tauri-drag-region />
      <div :id="actionsId" :class="ns.e('actions')">
        <slot name="actions" />
      </div>
    </div>
    <div v-if="showWindowControls" :class="ns.e('controls')">
      <z-tooltip content="最小化" placement="bottom">
        <button
          type="button"
          :class="ns.e('btn')"
          aria-label="最小化"
          @click="emit('minimize')"
        >
          <svg viewBox="0 0 10 10" aria-hidden="true">
            <path d="M1 5h8" />
          </svg>
        </button>
      </z-tooltip>
      <z-tooltip :content="maximized ? '还原' : '最大化'" placement="bottom">
        <button
          type="button"
          :class="ns.e('btn')"
          :aria-label="maximized ? '还原' : '最大化'"
          @click="emit('toggle-maximize')"
        >
          <svg v-if="maximized" viewBox="0 0 10 10" aria-hidden="true">
            <path d="M3.5 1.5h5v5h-1.5" />
            <path d="M1.5 3.5h5v5h-5z" />
          </svg>
          <svg v-else viewBox="0 0 10 10" aria-hidden="true">
            <path d="M1.5 1.5h7v7h-7z" />
          </svg>
        </button>
      </z-tooltip>
      <z-tooltip content="关闭窗口" placement="bottom">
        <button
          type="button"
          :class="[ns.e('btn'), ns.em('btn', 'close')]"
          aria-label="关闭窗口"
          @click="emit('close')"
        >
          <svg viewBox="0 0 10 10" aria-hidden="true">
            <path d="M1.5 1.5l7 7M8.5 1.5l-7 7" />
          </svg>
        </button>
      </z-tooltip>
    </div>
  </header>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useNamespace } from '@zoryn/hooks'
import ZTooltip from '@zoryn/components/tooltip'
import type { AppTitleBarPlatform } from './types'

defineOptions({
  name: 'ZAppTitleBar',
})

const props = withDefaults(
  defineProps<{
    dark?: boolean
    maximized?: boolean
    showWindowControls?: boolean
    platform?: AppTitleBarPlatform
  }>(),
  {
    dark: false,
    maximized: false,
    showWindowControls: false,
    platform: 'web',
  }
)

const emit = defineEmits<{
  minimize: []
  'toggle-maximize': []
  close: []
}>()

const ns = useNamespace('app-title-bar')
const isMac = computed(() => props.platform === 'darwin')
const navId = 'app-title-bar-menu'
const actionsId = 'app-title-bar-actions'
</script>
